import { Col, Divider, Row, Typography } from "antd";

import { Card } from '@hdi-seguros/web-components.card';

import { COLORS } from "../../../../config/themes/colors";

interface Span {
    span: number;
}

export interface ColumnSizes {
    xs?: Span;
    sm?: Span;
    md?: Span;
    lg?: Span;
    xl?: Span;
    xxl?: Span;
}
export interface Column {
    label: string, 
    value?: string | JSX.Element | number, 
    isLikeTitle?: boolean, 
    valueInBold?: boolean,
    columnSize?: ColumnSizes;
}

export const _renderColumns = (columns: Array<Column>) => (
    <>
        { 
            columns?.map(({ label, value = '-', valueInBold = false, isLikeTitle = false, columnSize = { xs: { span: 12 }, sm: { span: 8 } } }, index) => (
                <Col { ...columnSize } style={{ paddingRight: 15 }} key={ `col-${label}-${index}` } >
                    <Row>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }} >
                            { label }
                        </Typography.Text>
                    </Row>
                    <Row>   
                        {
                            typeof value === 'string'
                                ? (
                                    <Typography.Text strong={ valueInBold } style={{ fontSize: isLikeTitle ? 20 : 14, wordBreak: 'initial' }} >
                                        { value }
                                    </Typography.Text> 
                                )
                                : <div style={{ marginTop: '0.2rem' }} className="w-100">{value}</div>
                        }
                    </Row>
                </Col>
            )) 
        }
    </>
)

export const _renderSection = (title: string = '', key: string = '', columns: Array<Column>, children: any = false, hasDivider = true ) => (
    <>
        <Typography.Title level={ 4 } style={{ margin: 0, marginBottom: 10, marginTop: 20, color: COLORS.principal[100] }} id={ key } >
            { title }    
        </Typography.Title>

        <Row style={{ rowGap: 10 }} >
            { _renderColumns( columns ) }
        </Row>
        
        {children && (
            <Row style={{ rowGap: 10 }} >
                { children }
            </Row>
        )}

        {
            hasDivider
                ? <Divider style={{ minWidth: '90%', width: '98%' }} /> 
                : <></>
        }
        
    </>
)

export const _renderCard = (key: string | number, columns: Array<Column>) => (
    <Card title='' style={{ marginTop: '0.5rem', background: COLORS.neutrals[15] }} key={key}>
        <Row gutter={[16, 16]}>
            { _renderColumns( columns ) }
        </Row>
    </Card>
)